import Button from '../../../../../../../components/bases/button/button';
import Tooltip from '../../../../../../../components/bases/tooltips/tooltip';

import './filter.css';

import React, { useCallback } from 'react';

import FilterIcon from '../../assets/icons/filter.png';
import BlueIcon from '../../assets/icons/blue.png';
import GreenIcon from '../../assets/icons/green.png';
import CyanIcon from '../../assets/icons/cyan.png';
import RedIcon from '../../assets/icons/red.png';
import MagentaIcon from '../../assets/icons/magenta.png';
import YellowIcon from '../../assets/icons/yellow.png';
import WhiteIcon from '../../assets/icons/white.png';
import CancelIcon from '../../assets/icons/cancel.png';
import ActionIcon from '../../assets/icons/action.png';
import Font from '../../assets/icons/font.png';
import TextBox from '../../assets/icons/text-box.png';

import { isDigit, trapFocusElements } from '../../../common/functions';

const Filter = React.forwardRef((props, ref) => {
  const [filterVisible, setFilterVisible] = React.useState(false);
  const [actionVisible, setActionVisible] = React.useState(false);
  const [min, setMin] = React.useState('');
  const [max, setMax] = React.useState('');
  const [isReverseSearch, setIsReverseSearch] = React.useState(false);
  const [duplicateTo, setDuplicateTo] = React.useState('');
  const [cutAndPasteTo, setCutAndPasteTo] = React.useState('');
  const [align, setAlign] = React.useState(null);
  const [searchWord, setSearchWord] = React.useState('');
  const [caseSensitive, setCaseSensitive] = React.useState(false);
  const [wholeWord, setWholeWord] = React.useState(false);

  const colors = [
    {
      img: BlueIcon,
      type: 'button',
      disable: false,
      fr: 'Bleu',
      en: 'Blue',
      nochangecolor: true,
      key: { key: 'BLUE', cat: 'transcriptshortcut' },
    },
    {
      img: GreenIcon,
      type: 'button',
      disable: false,
      fr: 'Vert',
      en: 'Green',
      nochangecolor: true,
      key: { key: 'GREEN', cat: 'transcriptshortcut' },
    },
    {
      img: CyanIcon,
      type: 'button',
      disable: false,
      fr: 'Cyan',
      en: 'Cyan',
      nochangecolor: true,
      key: { key: 'CYAN', cat: 'transcriptshortcut' },
    },
    {
      img: RedIcon,
      type: 'button',
      disable: false,
      fr: 'Rouge',
      en: 'Red',
      nochangecolor: true,
      key: { key: 'RED', cat: 'transcriptshortcut' },
    },
    {
      img: MagentaIcon,
      type: 'button',
      disable: false,
      fr: 'Magenta',
      en: 'Magenta',
      nochangecolor: true,
      key: { key: 'MAGENTA', cat: 'transcriptshortcut' },
    },
    {
      img: YellowIcon,
      type: 'button',
      disable: false,
      fr: 'Jaune',
      en: 'Yellow',
      nochangecolor: true,
      key: { key: 'YELLOW', cat: 'transcriptshortcut' },
    },
    {
      img: WhiteIcon,
      type: 'button',
      disable: false,
      fr: 'Blanc',
      en: 'White',
      nochangecolor: true,
      key: { key: 'WHITE', cat: 'transcriptshortcut' },
    },
  ];

  // 0 = left , 1 = right , 2 = center, 3 = manual
  const aligns = [
    {
      id: 0,
      fr: 'Gauche',
      en: 'Left',
    },
    {
      id: 1,
      fr: 'Droite',
      en: 'Right',
    },
    {
      id: 2,
      fr: 'Centré',
      en: 'Center',
    },
    {
      id: 3,
      fr: 'Manuel',
      en: 'Manual',
    },
  ];

  /*React.useEffect(() => {
    if (!filterVisible) {
      onClearFilter();
    }
  }, [filterVisible]);

  React.useEffect(() => {
    if (!actionVisible) {
      onClearAction();
    }
  }, [actionVisible]);*/

  React.useImperativeHandle(ref, () => ({
    onKeyDown(event) {
      event.preventDefault();
      event.stopPropagation();

      if (event.key === 'Tab') {
        onTab(event);
      }
    },
  }));

  React.useEffect(() => {
    props.onDisplayFilter(filterVisible || actionVisible);
  }, [filterVisible, actionVisible, props]);

  React.useEffect(() => {

    if (min === "" || max === "") {
      return;
    }

    props.onSelectRangeSubtitles(
      Number.parseInt(min),
      Number.parseInt(max),
      isReverseSearch
    );
  }, [min, max, isReverseSearch]);

  React.useEffect(() => {
    props.onSelectAlign(align === '' ? null : Number.parseInt(align));
  }, [align]);

  React.useEffect(() => {
    props.onSearchWordOnSubtitles(searchWord, caseSensitive, wholeWord);
  }, [searchWord, caseSensitive, wholeWord]);

  const onClearFilter = useCallback(() => {
    setMin('');
    setMax('');
    setIsReverseSearch(false);
    setAlign(null);
    setSearchWord('');
    setCaseSensitive(false);
    setWholeWord(false);

    props.onSelectSubtitles(false);
    props.onClearFilteredSubtitles();
  }, [props]);

  const onClearAction = useCallback(() => {
    setDuplicateTo('');
    setCutAndPasteTo('');
    onClearFilter();
    //props.onSelectSubtitles(false);
  }, [onClearFilter]);

  const onInputTextKeyDown = (event, action) => {
    event.preventDefault();
    event.stopPropagation();

    const input = event.target;

    if (event.key === 'Tab') {
      onTab(event);
      return;
    }

    let text;
    let callback;
    let onlyDigits = true;

    switch (action) {
      case 'min':
        text = min;
        callback = setMin;
        break;

      case 'max':
        text = max;
        callback = setMax;
        break;

      case 'duplicate':
        text = duplicateTo;
        callback = setDuplicateTo;
        break;

      case 'searchWord':
        text = searchWord;
        callback = setSearchWord;
        onlyDigits = false;
        break;

      case 'cutpaste':
        text = cutAndPasteTo;
        callback = setCutAndPasteTo;
        break;

      default:
        return;
    }

    if (event.ctrlKey) {
      if (event.key === 'a') {
        input.setSelectionRange(0, input.value.length);
        return;
      }

      if (event.key === 'ArrowLeft') {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        if (start === 0) return;

        input.setSelectionRange(start - 1, end);
        return;
      }

      if (event.key === 'ArrowRight') {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        if (end === input.value.length) return;

        input.setSelectionRange(start, end + 1);
        return;
      }
    }

    if (event.key === 'Backspace') {
      onBackspace(input, text, callback);
      return;
    }

    if (event.key === 'Delete') {
      onDelete(input, text, callback);
      return;
    }

    if (event.key === 'ArrowLeft') {
      if (input.selectionStart === 0) return;

      setCursorPosition(input, input.selectionStart - 1);
      return;
    }

    if (event.key === 'ArrowRight') {
      if (input.selectionStart === input.value.length) return;

      setCursorPosition(input, input.selectionStart + 1);
      return;
    }

    if (event.key === 'Home') {
      setCursorPosition(input, 0);
      return;
    }

    if (event.key === 'End') {
      setCursorPosition(input, input.value.length);
      return;
    }

    var char = event.key;

    if (char.length > 1) {
      return;
    }

    if ((onlyDigits && isDigit(char)) || !onlyDigits) {
      const value = text + (event.ctrlKey ? char.toUpperCase() : char);
      callback(value);
    }

    return;
  };

  const onTab = (event) => {
    const parentElement = document.querySelector('.panel.active');
    const currentElement = document.activeElement;
    trapFocusElements(
      parentElement,
      currentElement,
      'button, input, [role="button"]',
      event.shiftKey
    );
  };

  const onReverseSearchKeyDown = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (event.key === 'Tab') {
      onTab(event);
      return;
    }

    if (event.key === 'Enter') {
      setIsReverseSearch(!isReverseSearch);
      return;
    }
  };

  const onButtonKeyDown = (event, callback) => {
    event.preventDefault();
    event.stopPropagation();

    if (event.key === 'Tab') {
      onTab(event);
      return;
    }

    if (event.key === 'Enter') {
      callback();
      return;
    }
  };

  const onRadioButtonKeyDown = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (event.key === 'Tab') {
      onTab(event);
      return;
    }

    if (event.key === 'Enter') {
      setAlign(event.target.value);
      return;
    }
  };

  const onBackspace = (input, text, callback) => {
    let start = input.selectionStart;
    let end = input.selectionEnd;

    const value = text.substring(0, start - 1) + text.substring(end);

    updateText(input, callback, value, start, end);
  };

  const onDelete = (input, text, callback) => {
    let start = input.selectionStart;
    let end = input.selectionEnd;

    const value = text.substring(0, start) + text.substring(end + 1);

    updateText(input, callback, value, start, end);
  };

  const updateText = (input, callback, value, start, end) => {
    callback(value);

    setCursorPosition(input, start);
  };

  const setCursorPosition = (inputElement, position) => {
    setTimeout(() => {
      inputElement.setSelectionRange(position, position);
      inputElement.scrollLeft = inputElement.scrollWidth;
    }, 0);
  };

  if (props.readOnly) {
    return <></>;
  }

  return (
    <div className="listst-panels" ref={ref}>
      <div className="listst-panels-buttons">
        <Button
          tooltip={{
            fr: 'Filtres',
            en: 'Filter',
          }}
          image={FilterIcon}
          width={16}
          height={16}
          onClick={() => {
            setFilterVisible(!filterVisible);
            setActionVisible(false);
          }}
          onKeyDown={(event) => {
            onButtonKeyDown(event, () => setFilterVisible(!filterVisible));
            setActionVisible(false);
          }}
          align="top-right"
        ></Button>

        <Button
          tooltip={{
            fr: 'Actions',
            en: 'Actions',
          }}
          image={ActionIcon}
          width={16}
          height={16}
          onClick={() => {
            setActionVisible(!actionVisible);
            setFilterVisible(false);
          }}
          onKeyDown={(event) => {
            onButtonKeyDown(event, () => setActionVisible(!actionVisible));
            setFilterVisible(false);
          }}
          align="top-right"
        ></Button>
      </div>
      <div className={'panel' + (filterVisible ? ' active' : '')}>
        <div className="close">
          <Button
            tooltip={{
              fr: 'Fermer',
              en: 'Close',
            }}
            image={CancelIcon}
            width={16}
            height={16}
            onClick={() => {
              setFilterVisible(false);
            }}
            onKeyDown={(event) =>
              onButtonKeyDown(event, () => setFilterVisible(false))
            }
            align="top-right"
          ></Button>
        </div>
        <p className="title"> {props.lang === 'fr' ? 'FILTRES' : 'FILTERS'}</p>
        <div className="selection">
          <fieldset>
            <legend>
              <span className="label">
                {props.lang === 'fr'
                  ? 'Sélectionner les sous-titres sur une plage de :'
                  : 'Select subtitles from a range of:'}
              </span>
            </legend>

            <div className="range">
              <div className="group">
                <label htmlFor="txtMin">Min</label>
                <input
                  type="tel"
                  id="txtMin"
                  value={min}
                  onChange={(e) => setMin(e.target.value)}
                  onKeyDown={(e) => onInputTextKeyDown(e, 'min')}
                  aria-describedby="lblSelection"
                ></input>
              </div>
              <p className="text">{props.lang === 'fr' ? 'à' : 'of'}</p>
              <div className="group">
                <label htmlFor="txtMax">Max</label>
                <input
                  type="tel"
                  id="txtMax"
                  value={max}
                  onChange={(e) => setMax(e.target.value)}
                  onKeyDown={(e) => onInputTextKeyDown(e, 'max')}
                  aria-describedby="lblSelection"
                ></input>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="reverse-search">
          <input
            id="chkReverseSearch"
            type="checkbox"
            checked={isReverseSearch}
            onChange={(e) => setIsReverseSearch(e.target.checked)}
            onKeyDown={(e) => onReverseSearchKeyDown(e)}
          />
          <label className="label" htmlFor="chkReverseSearch">
            {props.lang === 'fr' ? 'Recherche inversée' : 'Reverse search'}
          </label>
        </div>
        <hr />

        <div className="color">
          <fieldset>
            <legend>
              <span className="label">
                {props.lang === 'fr'
                  ? 'Sélectionner les sous-titres ayant la couleur :'
                  : 'Select subtitles with the color:'}
              </span>
            </legend>

            <div className="buttons">
              {colors.map((color) => {
                return (
                  <div className="item" key={color.key.key}>
                    <Tooltip text={props.lang === 'fr' ? color.fr : color.en}>
                      <Button
                        nochangecolor={color.nochangecolor}
                        disable={color.disable}
                        image={color.img}
                        onClick={props.onSelectColor}
                        onKeyDown={(event) =>
                          onButtonKeyDown(event, props.onSelectColor)
                        }
                        datas={color.key}
                        width={20}
                        height={20}
                      ></Button>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
          </fieldset>
        </div>
        <hr />
        <div className="align">
          <fieldset>
            <legend>
              <span className="label">
                {props.lang === 'fr'
                  ? `Sélectionner les sous-titres ayant l'alignement à :`
                  : 'Select subtitles with the alignment to:'}
              </span>
            </legend>

            <div className="radiobuttons">
              {aligns.map((data) => {
                return (
                  <div className="radiobutton" key={data.id}>
                    <input
                      type="radio"
                      name="align"
                      id={data.en.toLowerCase()}
                      value={data.id}
                      checked={align === data.id.toString()}
                      onChange={(e) => setAlign(e.target.value)}
                      onKeyDown={onRadioButtonKeyDown}
                    />
                    <label htmlFor={data.en.toLowerCase()}>
                      {props.lang === 'fr' ? data.fr : data.en}
                    </label>
                  </div>
                );
              })}
            </div>
          </fieldset>
        </div>
        <hr />
        <div className="control">
          <label className="label" htmlFor="txtSearchWord">
            {props.lang === 'fr'
              ? `Sélectionner les sous-titres ayant le mot :`
              : 'Select subtitles with the word:'}
          </label>
          <div className="flex">
            <input
              type="text"
              id="txtSearchWord"
              value={searchWord}
              onChange={(e) => setSearchWord(e.target.value)}
              onKeyDown={(e) => onInputTextKeyDown(e, 'searchWord')}
            />

            <Button
              id="btnCaseSensitive"
              tooltip={{
                fr: 'Respecter la casse',
                en: 'Case sensitive',
              }}
              image={Font}
              width={16}
              height={16}
              toggle={true}
              toggled={caseSensitive}
              onClick={() => setCaseSensitive(!caseSensitive)}
            ></Button>

            <Button
              id="btnMotEntier"
              tooltip={{
                fr: 'Mot entier',
                en: 'Whole word',
              }}
              image={TextBox}
              width={16}
              height={16}
              toggle={true}
              toggled={wholeWord}
              onClick={() => setWholeWord(!wholeWord)}
            ></Button>
          </div>
        </div>
        <hr />
        <div className="actions">
          <button
            type="button"
            onClick={onClearFilter}
            onKeyDown={(event) => onButtonKeyDown(event, onClearFilter)}
          >
            {props.lang === 'fr' ? 'Effacer les filtres' : 'Clear filters'}
          </button>
        </div>
      </div>
      <div className={'panel' + (actionVisible ? ' active' : '')}>
        <div className="close">
          <Button
            tooltip={{
              fr: 'Fermer',
              en: 'Close',
            }}
            image={CancelIcon}
            width={16}
            height={16}
            onClick={() => {
              setActionVisible(false);
            }}
            onKeyDown={(event) =>
              onButtonKeyDown(event, () => setActionVisible(false))
            }
            align="top-right"
          ></Button>
        </div>
        <p className="title"> {props.lang === 'fr' ? 'ACTIONS' : 'ACTIONS'}</p>
        <div className="duplication">
          <fieldset>
            <legend>
              <span className="label">
                {props.lang === 'fr'
                  ? 'Dupliquer une plage de sous-titres vers un autre endroit dans la liste :'
                  : 'Duplicates a subtitle range to another location in the list'}
              </span>
            </legend>

            <div className="control">
              <label className="label" htmlFor="txtDuplication">
                {props.lang === 'fr' ? 'N° sous-titre' : 'Subtitle No.'}
              </label>
              <input
                type="tel"
                id="txtDuplication"
                value={duplicateTo}
                onChange={(e) => setDuplicateTo(e.target.value)}
                onKeyDown={(e) => onInputTextKeyDown(e, 'duplicate')}
              ></input>
              <button
                type="button"
                onKeyDown={(event) =>
                  onButtonKeyDown(event, () =>
                    props.onDuplicateSubtitles(Number.parseInt(duplicateTo))
                  )
                }
                onClick={() =>
                  props.onDuplicateSubtitles(Number.parseInt(duplicateTo))
                }
              >
                {props.lang === 'fr' ? 'Dupliquer' : 'Duplicate'}
              </button>
            </div>
          </fieldset>
        </div>
        <hr />

        <div className="cut-paste">
          <fieldset>
            <legend>
              <span className="label">
                {props.lang === 'fr'
                  ? 'Couper une plage de sous-titres et la coller vers un autre endroit dans la liste :'
                  : 'Cut a subtitle range and paste it elsewhere in the list:'}
              </span>
            </legend>

            <div className="control">
              <label className="label" htmlFor="txtCutPaste">
                {props.lang === 'fr' ? 'N° sous-titre' : 'Subtitle No.'}
              </label>
              <input
                type="tel"
                id="txtCutPaste"
                value={cutAndPasteTo}
                onChange={(e) => setCutAndPasteTo(e.target.value)}
                onKeyDown={(e) => onInputTextKeyDown(e, 'cutpaste')}
              ></input>
              <button
                type="button"
                onKeyDown={(event) =>
                  onButtonKeyDown(event, () =>
                    props.onCutAndPasteSubtitles(Number.parseInt(cutAndPasteTo))
                  )
                }
                onClick={() =>
                  props.onCutAndPasteSubtitles(Number.parseInt(cutAndPasteTo))
                }
              >
                {props.lang === 'fr' ? 'Couper et coller' : 'Cut and paste'}
              </button>
            </div>
          </fieldset>
        </div>

        <hr />
        <div className="color">
          <fieldset>
            <legend>
              <span className="label">
                {props.lang === 'fr'
                  ? 'Appliquer la couleur sur les sous-titres sélectionnées :'
                  : 'Apply color to the selected subtitles:'}
              </span>
            </legend>

            <div className="buttons">
              {colors.map((color) => {
                return (
                  <div className="item" key={color.key.key}>
                    <Tooltip text={props.lang === 'fr' ? color.fr : color.en}>
                      <Button
                        nochangecolor={color.nochangecolor}
                        disable={color.disable}
                        image={color.img}
                        onClick={props.onSetColor}
                        onKeyDown={(event) =>
                          onButtonKeyDown(event, props.onSetColor)
                        }
                        datas={color.key}
                        width={20}
                        height={20}
                      ></Button>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
          </fieldset>
        </div>
        <hr />
        <div className="actions">
          <button
            type="button"
            onClick={() => props.onDeleteSelectedSubtitles()}
            onKeyDown={(event) =>
              onButtonKeyDown(event, props.onDeleteSelectedSubtitles)
            }
          >
            {props.lang === 'fr'
              ? 'Supprimer les sous-titres sélectionnées'
              : 'Delete selected subtitles'}
          </button>

          <button
            type="button"
            onClick={onClearAction}
            onKeyDown={(event) => onButtonKeyDown(event, onClearAction)}
          >
            {props.lang === 'fr' ? 'Effacer les filtres' : 'Clear filters'}
          </button>
        </div>
      </div>
    </div>
  );
});

export default Filter;
